export default "__VITE_ASSET__DMs3IteP__"